module.exports = __webpack_public_path__ + "static/media/label-icon.0d4822ab.svg";